import { GridWidget } from '../types';

interface StockExplorerProps extends GridWidget {}

const TABLE_COLUMNS = [
  { label: 'widget.stockExplorer.name', fixed: true, t: 'name' },
  { label: 'widget.stockExplorer.symbol', t: 'symbol' },
  { label: 'widget.stockExplorer.lastPrice', fixed: true, t: 'lastPrice' },
  {
    label: 'widget.stockExplorer.pricePerformanceDaily',
    fixed: true,
    t: 'pricePerformanceDaily',
  },
  { label: 'widget.stockExplorer.weeklyHighest', t: 'weeklyHighest' },
  { label: 'widget.stockExplorer.weeklyLowest', t: 'weeklyLowest' },
  {
    label: 'widget.stockExplorer.pricePerformanceWeekly',
    t: 'pricePerformanceWeekly',
  },
  { label: 'widget.stockExplorer.volume', t: 'volume' },
  { label: 'widget.stockExplorer.marketCap', t: 'marketCap' },
  { label: 'widget.stockExplorer.industry', t: 'industry' },
];

const LIMIT = 50;

export { TABLE_COLUMNS, LIMIT };
export type { StockExplorerProps };
